<template>
  <div v-loading.fullscreen="loading" element-loading-text="加载中">
    <el-card>
      <condition-search :query-items="queryItems" :search-param="searchParam" @search="search" @reset="reset" />
    </el-card>
    <el-card>
      <el-table ref="dataTable" :height="heightStyleObj" :data="pageListData" highlight-current-row border @sort-change="handleSortChange($event)">
        <el-table-column prop="" width="60" label="序号" show-overflow-tooltip>
          <template slot-scope="{ $index }">
            {{ $index + 1 + (searchParam.pageNum - 1) * searchParam.pageSize }}
          </template>
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="warehouseName" width="120px" label="仓库名称" />
        <el-table-column show-overflow-tooltip prop="materialName" min-width="120px" label="物料名称" />
        <el-table-column show-overflow-tooltip prop="specification" min-width="120px" label="物料规格型号">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="number" sortable="custom" width="120px" label="当前库存"></el-table-column>
<!--        <el-table-column show-overflow-tooltip prop="outNumber" sortable="custom" width="120px" label="出库数量"></el-table-column>-->
        <el-table-column show-overflow-tooltip prop="freezeNumber" sortable="custom" width="120px" label="冻结"></el-table-column>
        <el-table-column show-overflow-tooltip prop="diCode" width="140px" label="产品DI">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="materialCode" width="120px" label="物料编码" />
        <el-table-column show-overflow-tooltip prop="batchNumber" min-width="120px" label="批号"/>
        <el-table-column show-overflow-tooltip prop="packLevel" width="120px" label="包装级别">
        </el-table-column>
        <el-table-column show-overflow-tooltip prop="prodDate" sortable="custom" width="120px" label="生产日期">
          <template slot-scope="{ row }">
            {{ row.prodDate ? parseTime(row.prodDate, '{y}-{m}-{d}') : null }}
          </template>
        </el-table-column>

        <el-table-column show-overflow-tooltip prop="expiryDate" sortable="custom" width="120px" label="失效日期">
          <template slot-scope="{ row }">
            {{ row.expiryDate ? parseTime(row.expiryDate, '{y}-{m}-{d}') : null }}
          </template>
        </el-table-column>

        <el-table-column label="操作" fixed="right" width="180" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="$btnsPermission('realTimeInventory:ck')" type="text" @click="handlePreview(row)">查看</el-button>
          </template>
        </el-table-column>
      </el-table>
      <pagination v-show="searchParam.total > 0" :total="searchParam.total" :page.sync="searchParam.pageNum"
        :limit.sync="searchParam.pageSize" @pagination="getPageListData" />
    </el-card>
    <detialInventory v-if="previewShow" :dict-obj="dictObj" :visible="previewShow" :inventory-info="inventoryInfo"
      @close="close">
    </detialInventory>
  </div>
</template>

<script>
import { getDict } from '@/api/common'
import { getInventoryList } from '@/api/invertory'
import detialInventory from './components/detialInventory'
import { getWareHouse } from '../../api/warehouse'
export default {
  components: {
    detialInventory,
  },
  data() {
    return {
      heightStyleObj: '',
      loading: true, // 遮罩
      previewShow: false,
      pageListData: [], // 列表数据
      queryItems: [
        {
          label: '关键字',
          field: 'searchValue',
          placeholder: '物料编码/产品名称/规格型号/DI码/批号',
          width: '300px',
          type: 'input'
        },
        {
          label: '仓库名称',
          field: 'warehouseId',
          type: 'select',
          options: []
        },
      ],
      searchParam: { // 查询参数
        pageNum: 1,
        pageSize: 10,
        total: 0,
        isAsc: '',
        orderByColumn: 'T1.update_time'
      },
      dictObj: {
        receiptDeliveryState: []
      },
    }
  },


  created() {
    this.getWareHouse()
    this.getPageListData()
    this.heightStyleObj = window.innerHeight - 405 + 'px'
    this.getDicts(['receiptDeliveryState'])


  },
  methods: {
    handlePreview(row) {
      this.previewShow = true
      this.inventoryInfo = JSON.parse(JSON.stringify(row))
    },
    close() {
      this.previewShow = false
      this.getPageListData()
    },
    // 获取入库仓库
    getWareHouse() {
      getWareHouse({pageSize:99999,pageNum:1}).then((res) => {
        this.queryItems[this.queryItems.findIndex(item => item.field === 'warehouseId')].options = res.rows.map(item => {
          return {
            dictValue: item.id,
            dictLabel: item.name
          }
        })
      })
    },
    // 获取字典
    getDicts(list) {
      list.forEach(dictType => {
        getDict({ dictType }).then((res) => {

          if (dictType === 'receiptDeliveryState') {
            const da = res.rows.filter(item => item.dictLabel !== '报废' && item.dictLabel !== '重入库报废' && item.dictLabel !== '重入库可用')
            this.dictObj['receiptDeliveryState'] = da
          }else {
            this.dictObj[dictType] = res.rows
          }

        })
      })
    },


    // 查询
    search() {
      this.searchParam.pageNum = 1
      this.getPageListData()
    },
    // 重置查询
    reset() {
      this.searchParam = Object.assign(this.$data.searchParam, this.$options.data.call(this)).searchParam
      this.getPageListData()
    },

    // 获取列表数据
    getPageListData() {
      this.loading = true
      const searchParam = JSON.parse(JSON.stringify(this.searchParam))
      if (searchParam.dateTime) {
        const [startTime, endTime] = searchParam.dateTime
        searchParam.startTime = startTime
        searchParam.endTime = endTime
        delete searchParam.dateTime
      }
      getInventoryList(searchParam).then(res => {
        this.searchParam.total = res.total
        this.pageListData = res.rows
      }).finally(() => {
        this.loading = false
      })
    },
    handleSortChange (sort) {
      const { order, prop } = sort
      switch (prop) {
        case 'number':
          this.searchParam.orderByColumn = 'T1.number'
          break
        case 'prodDate':
          this.searchParam.orderByColumn = 'T1.material_code'
          break
        case 'expiryDate':
          this.searchParam.orderByColumn = 'T1.expiry_date'
          break
        case 'freezeNumber':
          this.searchParam.orderByColumn = 'T1.freeze_number'
          break
        default:
          this.searchParam.orderByColumn = 'T1.update_time'
      }

      if (order === 'descending') {
        this.searchParam.isAsc = 'desc'
      }else if(order === null){
        this.searchParam.isAsc = null
        this.searchParam.orderByColumn = 'T1.update_time'
      } else {
        this.searchParam.isAsc = 'asc'
      }
      console.log(this.searchParam)
      this.search()
    }
  }
}
</script>
